<template>
  <div
    v-click-outside="hide"
    class="filter__order"
    :class="{ 'filter__order--active': sortView.visible }"
    @click="sortView.toggleMenu()"
  >
    <div class="filter__active">
      <span class="filter__icon iconfont" :class="sortView.activeOptIcon"></span
      >{{ sortView.displayedSortOptionName }}
    </div>
    <span class="filter__arr iconfont iarrow-down"></span>
    <transition name="fade">
      <ul v-show="sortView.visible" class="filter__list">
        <li
          v-for="opt in sortView.options"
          :key="opt.name"
          class="filter__item"
          @click.prevent="opt.click()"
        >
          <span class="filter__icon iconfont" :class="opt.icon"></span
          >{{ opt.name }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { DocsView } from '@/models/doc'
import { DocsSortView } from '@/models/docs.sort'
import { assertNotNull } from '@/helpers/typing'

const props = defineProps<{
  view: DocsView
}>()

const sortView = ref(new DocsSortView(props.view, true))

function hide(): void {
  assertNotNull(sortView.value).hide()
}
</script>
